import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Input from '../Common/Input';
import Button from '../Common/Button';
import './AuthForm.css';

const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError(''); // Clear error on input change
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      await login(formData.email, formData.password);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Error al iniciar sesión');
    }
  };

  return (
    <div className="auth-container">
      <div className={`auth-card ${isLoading ? 'loading' : ''}`}>
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}
        
        <div className="auth-header">
          <div className="auth-logo">
            <div className="auth-logo-icon">SI</div>
          </div>
          <h1>Iniciar Sesión</h1>
          <p>
            Bienvenido al Asistente Conversacional de{' '}
            <span className="company-name">Suministros Industriales</span>
          </p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="alert alert-error">
              <div className="alert-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="15" y1="9" x2="9" y2="15"/>
                  <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
              </div>
              {error}
            </div>
          )}

          <Input
            type="email"
            name="email"
            label="Email Corporativo"
            value={formData.email}
            onChange={handleChange}
            placeholder="tu@empresa.com"
            required
            autoComplete="email"
          />

          <Input
            type="password"
            name="password"
            label="Contraseña"
            value={formData.password}
            onChange={handleChange}
            placeholder="••••••••••"
            required
            autoComplete="current-password"
          />

          <Button type="submit" variant="primary" fullWidth loading={isLoading}>
            {isLoading ? 'Iniciando Sesión...' : 'Acceder al Sistema'}
          </Button>
        </form>

        <div className="security-features">
          <h4>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            Seguridad Garantizada
          </h4>
          <div className="security-list">
            <div className="security-item">
              <div className="security-check"></div>
              Encriptación SSL/TLS
            </div>
            <div className="security-item">
              <div className="security-check"></div>
              Autenticación JWT
            </div>
            <div className="security-item">
              <div className="security-check"></div>
              Sesiones Seguras
            </div>
            <div className="security-item">
              <div className="security-check"></div>
              Datos Protegidos
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
